import React from 'react';
import ComingSoonPage from './componenets/ComingSoonPage';

export const BurialRequest = () => {
  return <ComingSoonPage title="Burial request" description="Information and next steps for families seeking burial support." image="/images/HomeSlider14.jpg" />;
}
